import { render, staticRenderFns } from "./modal-info.vue?vue&type=template&id=7dfda0a9&scoped=true&"
import script from "./modal-info.vue?vue&type=script&lang=js&"
export * from "./modal-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfda0a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dfda0a9')) {
      api.createRecord('7dfda0a9', component.options)
    } else {
      api.reload('7dfda0a9', component.options)
    }
    module.hot.accept("./modal-info.vue?vue&type=template&id=7dfda0a9&scoped=true&", function () {
      api.rerender('7dfda0a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/modal-info/modal-info.vue"
export default component.exports